import type { Cms_TitleTag } from '../services/cms';
import type { HtmlTagName } from '../types';

export const getTitleTag = (tag?: Cms_TitleTag, fallback?: HtmlTagName): HtmlTagName => {
  return (tag?.toLowerCase() as HtmlTagName) || fallback || 'h2';
};
